<p-toast />

<div class="card">

    <p-toolbar styleClass="mb-4">

        <ng-template pTemplate="start">

            <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" (onClick)="goBack()" />

        </ng-template>

        <ng-template pTemplate="end">

            <p-button label="New portal user" icon="pi pi-plus" (onClick)="openCreateDialog()" />

        </ng-template>

    </p-toolbar>



    <p-tabView>

        <p-tabPanel header="Portal users">

            <div class="grid mb-3">

                <div class="col-12 md:col-3">

                    <input pInputText class="w-full" placeholder="Customer ID" [(ngModel)]="filterCustomerId" />

                </div>

                <div class="col-12 md:col-3">

                    <input pInputText class="w-full" placeholder="Email" [(ngModel)]="filterEmail" />

                </div>

                <div class="col-12 md:col-2">

                    <input pInputText class="w-full" placeholder="Company" [(ngModel)]="filterCompany" />

                </div>

                <div class="col-12 md:col-2">

                    <input pInputText class="w-full" placeholder="Division" [(ngModel)]="filterDivision" />

                </div>

                <div class="col-12 md:col-2">

                    <p-button label="Search" icon="pi pi-search" class="w-full" (onClick)="applyFilters()" />

                </div>

            </div>



            <p-table

                [value]="users"

                [loading]="loading"

                [paginator]="true"

                [rows]="pageSize"

                [totalRecords]="totalRecords"

                [lazy]="true"

                (onLazyLoad)="onPage($event)"

                [rowsPerPageOptions]="[10, 20, 50]"

                dataKey="id"

                responsiveLayout="scroll"

            >

                <ng-template pTemplate="header">

                    <tr>

                        <th>Customer ID</th>

                        <th>Name</th>

                        <th>Email</th>

                        <th>Company</th>

                        <th>Division</th>

                        <th>Warehouse</th>

                        <th>Status</th>

                        <th>Actions</th>

                    </tr>

                </ng-template>

                <ng-template pTemplate="body" let-user>

                    <tr>

                        <td>{{ user.customerId }}</td>

                        <td>{{ user.customerName }}</td>

                        <td>{{ user.email }}</td>

                        <td>{{ user.company }}</td>

                        <td>{{ user.division }}</td>

                        <td>{{ user.warehouse }}</td>

                        <td>

                            <p-tag

                                [value]="user.portalEnabled ? 'Active' : 'Disabled'"

                                [severity]="user.portalEnabled ? 'success' : 'danger'"

                            />

                        </td>

                        <td>

                            <p-button

                                [label]="user.portalEnabled ? 'Disable' : 'Enable'"

                                [severity]="user.portalEnabled ? 'warn' : 'success'"

                                size="small"

                                class="mr-2"

                                (onClick)="togglePortal(user)"

                            />

                            <p-button label="Reset pwd" icon="pi pi-key" size="small" severity="secondary" (onClick)="resetPassword(user)" />

                        </td>

                    </tr>

                </ng-template>

                <ng-template pTemplate="emptymessage">

                    <tr>

                        <td colspan="8">No customer portal users found.</td>

                    </tr>

                </ng-template>

            </p-table>

        </p-tabPanel>



        <p-tabPanel header="Bulk import (CSV)">

            <div class="flex flex-column gap-3 bulk-import-panel">

                <p class="m-0 text-color-secondary">

                    Export your Excel as CSV with columns:

                    customerId, customerName, email, company, division, warehouse, status, phoneNo

                </p>



                <div class="flex flex-wrap gap-2 align-items-center">

                    <p-button label="Download template" icon="pi pi-download" severity="secondary" (onClick)="downloadTemplate()" />

                    <input type="file" accept=".csv" (change)="onImportFileSelected($event)" />

                    <span *ngIf="importFile">{{ importFile.name }}</span>

                </div>



                <div class="flex flex-wrap gap-2 align-items-center">

                    <p-button

                        label="Preview"

                        icon="pi pi-eye"

                        [loading]="importPreviewLoading"

                        [disabled]="!importFile"

                        (onClick)="previewImport()"

                    />

                    <div class="flex align-items-center gap-2">

                        <p-checkbox [(ngModel)]="importDryRun" [binary]="true" inputId="dryRun" />

                        <label for="dryRun">Dry run only (no Cognito writes)</label>

                    </div>

                    <p-button

                        label="Start import"

                        icon="pi pi-upload"

                        [loading]="importJobLoading"

                        [disabled]="!importFile || isImportRunning()"

                        (onClick)="startImport()"

                    />

                </div>



                <div *ngIf="importPreview" class="preview-summary flex flex-wrap gap-2">

                    <p-tag severity="info" [value]="'Total: ' + importPreview.totalRows" />

                    <p-tag severity="success" [value]="'OK: ' + importPreview.okCount" />

                    <p-tag severity="warn" [value]="'Skip: ' + importPreview.skipCount" />

                    <p-tag severity="danger" [value]="'Error: ' + importPreview.errorCount" />

                    <p-tag *ngIf="importPreview.truncated" severity="secondary" value="Preview truncated to 500 rows" />

                </div>



                <p-table *ngIf="importPreview?.rows?.length" [value]="importPreview!.rows" responsiveLayout="scroll">

                    <ng-template pTemplate="header">

                        <tr>

                            <th>Row</th>

                            <th>Customer ID</th>

                            <th>Email</th>

                            <th>Outcome</th>

                            <th>Message</th>

                        </tr>

                    </ng-template>

                    <ng-template pTemplate="body" let-row>

                        <tr>

                            <td>{{ row.rowNum }}</td>

                            <td>{{ row.customerId }}</td>

                            <td>{{ row.email }}</td>

                            <td>

                                <p-tag [value]="row.previewOutcome" [severity]="previewOutcomeSeverity(row.previewOutcome)" />

                            </td>

                            <td>{{ row.message }}</td>

                        </tr>

                    </ng-template>

                </p-table>



                <div *ngIf="importJob" class="import-job-status flex flex-column gap-2">

                    <div class="flex flex-wrap gap-2 align-items-center">

                        <strong>Job #{{ importJob.id }}</strong>

                        <p-tag [value]="importJob.status" />

                        <span>{{ importJob.processedRows }} / {{ importJob.totalRows }} processed</span>

                    </div>

                    <p-progressBar [value]="importProgressPercent()" />

                    <div class="flex flex-wrap gap-2">

                        <p-tag severity="success" [value]="'Created: ' + importJob.createdCount" />

                        <p-tag severity="warn" [value]="'Skipped: ' + importJob.skippedCount" />

                        <p-tag severity="danger" [value]="'Errors: ' + importJob.errorCount" />

                    </div>

                    <p-button

                        *ngIf="importJob.status === 'COMPLETED' && importJob.errorCount + importJob.skippedCount > 0"

                        label="Download errors CSV"

                        icon="pi pi-download"

                        severity="secondary"

                        (onClick)="downloadImportErrors()"

                    />

                </div>

            </div>

        </p-tabPanel>

    </p-tabView>

</div>



<p-dialog header="Create customer portal user" [(visible)]="createDialogVisible" [modal]="true" [style]="{ width: '36rem' }">

    <div class="flex flex-column gap-3">

        <div class="flex flex-column gap-1">

            <label class="text-sm font-medium">M3 customer lookup (min 3 chars)</label>

            <p-autoComplete

                [(ngModel)]="selectedM3Customer"

                [suggestions]="customerSearchOptions"

                (completeMethod)="searchM3Customers($event)"

                (onSelect)="onM3CustomerSelect($event)"

                field="CUSTOMER"

                placeholder="Search by customer number or name"

                styleClass="w-full"

                [dropdown]="true"

            />

        </div>

        <input pInputText class="w-full" placeholder="Customer ID *" [(ngModel)]="createData.customerId" />

        <input pInputText class="w-full" placeholder="Customer name *" [(ngModel)]="createData.customerName" />

        <input pInputText class="w-full" placeholder="Email *" [(ngModel)]="createData.email" />

        <div class="flex gap-2">

            <input pInputText class="flex-1" type="password" placeholder="Temporary password *" [(ngModel)]="createData.password" />

            <p-button label="Generate" severity="secondary" (onClick)="generateTempPassword()" />

        </div>

        <input pInputText class="w-full" placeholder="Company *" [(ngModel)]="createData.company" />

        <input pInputText class="w-full" placeholder="Division *" [(ngModel)]="createData.division" />

        <input pInputText class="w-full" placeholder="Warehouse *" [(ngModel)]="createData.warehouse" />

        <input pInputText class="w-full" placeholder="Phone" [(ngModel)]="createData.phoneNo" />

        <div class="flex align-items-center gap-2">

            <p-checkbox [(ngModel)]="mustChangePassword" [binary]="true" inputId="mcp" />

            <label for="mcp">Require password change on first login</label>

        </div>

        <small class="text-red-500" *ngIf="createSubmitted && !isCreateValid()">Fill all required fields with a valid email.</small>

    </div>

    <ng-template pTemplate="footer">

        <p-button label="Cancel" severity="secondary" (onClick)="createDialogVisible = false" />

        <p-button label="Create" (onClick)="createUser()" />

    </ng-template>

</p-dialog>


